import { useTheme, Box, Typography, Button } from "@mui/material";
import {
  WelcomeAndIntructionsPopUpRoot,
  WelcomeAndIntructionsPopUpItem,
} from "./WelcomeAndIntructionsPopUp.styles";
import RotateDesktopImg from "../../assets/instructions/camera_rotation_desktop.svg";
import ZoomDesktopImg from "../../assets/instructions/camera_zoom_desktop.svg";
import CameraPanDesktopImg from "../../assets/instructions/camera_pan_desktop.svg";
import RotateMobileImg from "../../assets/instructions/rotate-mobile_img.svg";
import ZoomMobileImg from "../../assets/instructions/zoom-mobile_img.svg";
import CloseIcon from "@mui/icons-material/Close";
import { LanguageSwitch } from "../LanguageSwitch";
import { useDevice } from "../../hooks/useDevice";
import { useSelectedOptions } from "../../context/SelectedOptionsContext";

export const WelcomeAndIntructionsPopUp = ({ onHandleClose }) => {
  const theme = useTheme();
  const { isTouch } = useDevice();
  const { currentTranslations } = useSelectedOptions();

  const iconsDesktop = [
    {
      imgSrc: RotateDesktopImg,
      ...currentTranslations?.welcomeInstructions?.desktop?.rotate,
    },
    {
      imgSrc: ZoomDesktopImg,
      ...currentTranslations?.welcomeInstructions?.desktop?.zoom,
    },
    {
      imgSrc: CameraPanDesktopImg,
      ...currentTranslations?.welcomeInstructions?.desktop?.cameraPan,
    },
  ];

  const iconsMobile = [
    {
      imgSrc: RotateMobileImg,
      ...currentTranslations?.welcomeInstructions?.mobile?.rotate,
    },
    {
      imgSrc: ZoomMobileImg,
      ...currentTranslations?.welcomeInstructions?.mobile?.zoom,
    },
  ];

  const instructions = isTouch ? iconsMobile : iconsDesktop;

  return (
    <WelcomeAndIntructionsPopUpRoot>
      <LanguageSwitch sx={{ right: { xs: 50, lg: 70 }, top: 10 }} />
      <Button
        variant="text"
        sx={{
          position: { xs: "fixed", lg: "absolute" },
          zIndex: 9,
          top: 0,
          right: { xs: -10, lg: 0 },
          color: theme?.palette?.companyColors?.secondary,
          fontSize: { xs: "1.75rem", md: "2.25rem" },
          transition: "all 0.3s ease",
        }}
        onClick={() => {
          onHandleClose(false, "click");
        }}
      >
        <CloseIcon
          sx={{
            padding: "3px 0 0",
            fontSize: "3.5rem",
          }}
        />
      </Button>
      <Typography
        className="instructions__title"
        variant="h4"
        sx={{
          fontSize: "3rem",
          fontWeight: 500,
          mb: { xs: "1.5rem", md: "0" },
        }}
      >
        {currentTranslations?.welcomeInstructions?.title}
      </Typography>
      <Box
        sx={{
          boxSizing: "border-box",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "center",
          flex: 1,
          gap: { xs: "2.5rem", md: "4.5rem" },
        }}
      >
        {instructions.map((item, index) => (
          <WelcomeAndIntructionsPopUpItem key={index}>
            <Box
              component="img"
              src={item.imgSrc}
              alt={item.alt}
              sx={{
                width: {
                  xs: "7rem",
                  sm: "5rem",
                  md: "7rem",
                  lg: "7rem",
                  xl: "4rem",
                },
              }}
            />
            <Box
              sx={{
                textAlign: "center",
                fontWeight: 300,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontSize: "1.6rem",
                  fontWeight: 700,
                  lineHeight: 1.1,
                  marginBottom: "0.25rem",
                  textAlign: "center",
                }}
              >
                {item.title}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  gap:
                    item.descriptionMouse && item.descriptionTrackpad && "1rem",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box component="span" sx={{ fontSize: "1.25rem" }}>
                  {item.descriptionMouse}
                </Box>
                {item.descriptionMouse && item.descriptionTrackpad && (
                  <Box component="span" sx={{ fontSize: "1.25rem" }}>
                    |
                  </Box>
                )}
                <Box component="span" sx={{ fontSize: "1.25rem" }}>
                  {item.descriptionTrackpad}
                </Box>
              </Box>
            </Box>
          </WelcomeAndIntructionsPopUpItem>
        ))}
      </Box>
    </WelcomeAndIntructionsPopUpRoot>
  );
};
